import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { UserAvatar } from "@/features/user-avatar";
import { Skeleton } from "@/components/ui/skeleton";

export function UserButton({
  asButton = true,
  user,
  variant = "outline",
  className,
  onClick,
  children,
}: {
  asButton?: boolean;
  user: any;
  variant?:
    | "default"
    | "secondary"
    | "outline"
    | "ghost"
    | "destructive"
    | null
    | undefined;
  className?: string;
  onClick?: () => void;
  children?: React.ReactNode;
}) {
  const Component = asButton ? Button : "div";

  return (
    <Component
      variant={asButton ? variant : undefined}
      className={cn(
        "w-full justify-between items-center px-2 py-6",
        !asButton && "flex py-2", // div일 때 추가 스타일
        className,
      )}
      onClick={onClick}
    >
      <div className="flex flex-1">
        <UserAvatar picture={user.picture ?? null} />
        <div className="grid text-left text-sm leading-tight pl-2">
          <span className="truncate font-semibold">
            {user.name || "Unknown"}
          </span>
          <span className="truncate text-xs">{user.email}</span>
        </div>
      </div>
      <div className="truncate text-xs">{children}</div>
    </Component>
  );
}

export function UserSkeleton() {
  return (
    <div className="flex items-center space-x-4">
      <Skeleton className="h-12 w-12 rounded-full" />
      <div className="space-y-2">
        <Skeleton className="h-4 w-[250px]" />
        <Skeleton className="h-4 w-[200px]" />
      </div>
    </div>
  );
}
